import { applyMiddleware, compose, createStore } from 'redux';
import { routerMiddleware } from 'react-router-redux';
import thunk from 'redux-thunk';
import makeRootReducer from './reducers';

class SingletonStore {
  constructor() {
    if (SingletonStore.instance) {
      return SingletonStore.instance;
    }
    SingletonStore.instance = this;
    this.store = null;
  }

  initialize(initialState = {}, browserHistory) {
    if (this.store) {
      console.warn('Store is already initialized. Returning existing instance.');
      return this.store;
    }

    // Middleware Configuration
    const middleware = [thunk, routerMiddleware(browserHistory)];

    // Store Enhancers
    const enhancers = [];

    let composeEnhancers = compose;

    if (__DEV__) {
      const composeWithDevToolsExtension = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__;
      if (typeof composeWithDevToolsExtension === 'function') {
        composeEnhancers = composeWithDevToolsExtension;
      }
    }

    // Store Instantiation
    this.store = createStore(
      makeRootReducer(),
      initialState,
      composeEnhancers(applyMiddleware(...middleware), ...enhancers)
    );
    this.store.asyncReducers = {};

    // HMR Setup
    if (module.hot) {
      module.hot.accept('./reducers', () => {
        const reducers = require('./reducers').default;
        this.store.replaceReducer(reducers(this.store.asyncReducers));
      });
    }

    return this.store;
  }

  getStore() {
    if (!this.store) {
      throw new Error('Store is not initialized. Call initialize() first.');
    }
    return this.store;
  }
}

const storeInstance = new SingletonStore();

export const initializeStore = (initialState, browserHistory) =>
  storeInstance.initialize(initialState, browserHistory);

export const getStore = () => storeInstance.getStore();

export default storeInstance;
